import { a as __rest } from '../../_tslib.esm.js';
import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import headingStyles from './Heading.styles.esm.js';
import { cn } from '../../utils/cn.esm.js';

const Heading = React__default.forwardRef((_a, ref) => {
  var {
      size = "md",
      as: Comp = "h2",
      className,
      inverse = false,
      children
    } = _a,
    otherProps = __rest(_a, ["size", "as", "className", "inverse", "children"]);
  // Generate the class names based on the size variants
  const {
    base: baseClasses,
    leading: leadingClasses
  } = headingStyles({
    size,
    inverse
  });
  const finalClasses = cn(baseClasses(), leadingClasses(), className);
  // Render the heading component
  return jsx(Comp, Object.assign({
    ref: ref,
    className: finalClasses
  }, otherProps, {
    children: children
  }));
});
Heading.displayName = "Heading";

export { Heading };
